import { render, staticRenderFns } from "./CloneToClinic.vue?vue&type=template&id=0ef7c281&scoped=true&"
import script from "./CloneToClinic.vue?vue&type=script&lang=js&"
export * from "./CloneToClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef7c281",
  null
  
)

export default component.exports